
const ApplicationConfig = 
// {
//   appName: ' 深度清理 ',
//   sample1: '释放',
//   sampleDesc1: '快速释放手机空间',
//   sample2: '删除',
//   sampleDesc2: '高效删除无用文件',
//   sample3: '整理',
//   sampleDesc3: '整理杂乱无章的相册',
//   sample4: '压缩',
//   sampleDesc4: '极致压缩照片和视频大小',
//   icpTitle: '深圳欢图智能科技有限公司 版权所有 © 深度清理',
//   icpUrl: '粤ICP备2024264396号-6',
//   conus: '联系我们：fanjinyuan@joytutech.com',
// };
// {
//   appName: ' 全能创作大师 ',
//   sample1: '创作智能体',
//   sampleDesc1: '海量智能体  覆盖生活与工作场景',
//   sample2: '漫画推文视频',
//   sampleDesc2: '一键打造爆款漫画推文视频',
//   sample3: '深度思考',
//   sampleDesc3: '全面接入 R1 深度思考',
//   sample4: '动漫写真',
//   sampleDesc4: '一键生成专属动漫形象',
//   icpTitle: '深圳欢图智能科技有限公司 版权所有 © 全能创作大师',
//   icpUrl: '粤ICP备2024264396号-4',
//   conus: '联系我们：fanjinyuan@joytutech.com',
// };
{
  appName: ' 秀影 ',
  sample1: '跨时空拥抱',
  sampleDesc1: '两张照片，跨时空相聚',
  sample2: '百变写真馆',
  sampleDesc2: '随你所想，千种变换',
  sample3: '旅游大片',
  sampleDesc3: '足不出户，游历全球',
  sample4: '百变发型',
  sampleDesc4: '百搭发型，完美匹配脸型',
  icpTitle: '深圳欢图智能科技有限公司 版权所有 © 秀影',
  icpUrl: '粤ICP备2024264396号-3',
  conus: '联系我们：fanjinyuan@joytutech.com',
};

export default ApplicationConfig;